import React from 'react';
import type { GroupBase, OptionProps } from 'react-select';
import { components } from 'react-select';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

//components
import AampeTooltip from '../shared/AampeTooltip/AampeTooltip';
// constants
import { SearchableSelectType } from './searchableSelect';

interface StyledProps {
    isDisabled?: boolean;
}

const SelectInfo: React.FC<
    React.PropsWithChildren<
        OptionProps<
            SearchableSelectType,
            boolean,
            GroupBase<SearchableSelectType>
        >
    >
> = (props) => (
    <components.Option {...props}>
        <Label isDisabled={props.data.disabled}>
            {props.data.trailingIcon && props.data.trailingIcon}
            <div>
                {props.data.info ? (
                    <AampeTooltip
                        arrow
                        placement="right"
                        title={props.data.info ?? ''}
                    >
                        <Title>{props.data.label}</Title>
                    </AampeTooltip>
                ) : (
                    props.data.label
                )}
            </div>
        </Label>
    </components.Option>
);

const Title = styled.div(() => ({ width: '100%' }));

const Label = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isDisabled',
})<StyledProps>(({ isDisabled }) => ({
    display: 'flex',
    alignItems: 'start',
    gap: aampeTheme.spacing4(2),
    color: isDisabled ? aampeTheme.colors.bordersWG01 : 'inherit',
    cursor: isDisabled ? 'not-allowed' : 'inherit',
}));
export default SelectInfo;
